import { InfoRow } from './InfoRow';
import { isUpdateDealDetailsFieldName } from '../../model/informationBlockFields';

import type {
    DateFieldCommitHandler,
    FieldEditHandler,
    FieldErrors,
    FieldFocusHandler,
    FieldInputHandler,
    InfoItem,
    UpdateFieldHandler,
    UpdateFieldKeyDownHandler,
} from '../../model/informationBlockFields';

type InfoSectionProps = {
    items: InfoItem[];
    fieldErrors: FieldErrors;
    onFieldBlur: UpdateFieldHandler;
    onFieldKeyDown: UpdateFieldKeyDownHandler;
    onFieldFocus: FieldFocusHandler;
    onFieldInput: FieldInputHandler;
    onFieldEdit: FieldEditHandler;
    onDateFieldCommit: DateFieldCommitHandler;
};

export const InfoSection = ({
    items,
    onFieldBlur,
    onFieldKeyDown,
    onFieldFocus,
    onFieldInput,
    onFieldEdit,
    onDateFieldCommit,
    fieldErrors,
}: InfoSectionProps) => (
    <dl className="m-0 flex w-full flex-col gap-3">
        {items.map((item) => (
            <InfoRow
                key={item.fieldName}
                {...item}
                errorMessage={
                    isUpdateDealDetailsFieldName(item.fieldName)
                        ? fieldErrors[item.fieldName]
                        : undefined
                }
                onFieldBlur={onFieldBlur}
                onFieldKeyDown={onFieldKeyDown}
                onFieldFocus={onFieldFocus}
                onFieldInput={onFieldInput}
                onFieldEdit={onFieldEdit}
                onDateFieldCommit={onDateFieldCommit}
            />
        ))}
    </dl>
);
